/* eslint-disable prettier/prettier */
<template>
    <div class="grid">
        <div class="grid-title">
            <h4>{{ $t("RATE_PMS") }}</h4>
            <v-btn color="primary" @click="$router.push({ name: 'ratePmsUpdate' })" :disabled="isLoading">
                <template>{{ $t("UPDATE_RATE_PMS") }}</template>
            </v-btn>
        </div>

        <v-spacer />
        <div class="grid-body py-3 border-top-unset" v-if="!isLoading">
            <div class="pb-3">
                <div class="d-flex px-3 pb-3 w-100 justify-content-between">
                    <div class="pt-0 d-flex w-100">
                        <label class="pr-0" style="padding-top: 11px; margin-right: 12px; white-space: nowrap;">
                            {{ $t("_HOTEL_CHAIN.CHAIN_LIST_HOTEL") }}
                        </label>
                        <v-autocomplete item-text="name" item-value="id" :items="hotels" v-model="selecedtHotels" outlined
                            chips dense multiple>
                            <template v-slot:prepend-item>
                                <p class="mx-3 mt-1"> <a class="text-primary"
                                        @click="selecedtHotels = hotels.map(e => e.id)">{{
                                            $t('SELECT_ALL') }}</a>
                                    | <a class="text-primary" @click="selecedtHotels = []">{{
                                        $t('UN_SELECT_ALL') }}</a>
                                </p>
                            </template>
                            <template v-slot:selection="{ item, index }">
                                <v-chip color="primary" v-if="index === 0" v-bind="item.attrs" :input-value="item.selected"
                                    close @click:close="removeChips(index, selecedtHotels)" @click="item.select">
                                    <p class="mb-0 text-truncate" style="max-width: 150px">{{ item.name }}</p>
                                </v-chip>
                                <span v-if="index === 1" class="grey--text caption">(+{{
                                    selecedtHotels.length - 1 }})</span>
                            </template>
                            <template slot="no-data">
                                <div class="no-data">{{ $t("NO_DATA") }}</div>
                            </template>
                        </v-autocomplete>
                    </div>
                    <div class="pt-0 d-flex w-100 ml-3">
                        <label class="pr-0" style="padding-top: 11px; margin-right: 12px; white-space: nowrap;">
                            {{ $t("ROOM_TYPE") }}
                        </label>
                        <v-autocomplete item-text="text" item-value="value" :items="listRooms" v-model="selectedRoomType"
                            outlined chips dense multiple>
                            <template v-slot:prepend-item>
                                <p class="mx-3 mt-1"> <a class="text-primary"
                                        @click="selectedRoomType = listRooms.map(e => e.value)">{{
                                            $t('SELECT_ALL') }}</a>
                                    | <a class="text-primary" @click="selectedRoomType = []">{{
                                        $t('UN_SELECT_ALL') }}</a>
                                </p>
                            </template>
                            <template v-slot:selection="{ item, index }">
                                <v-chip color="primary" v-if="index === 0" v-bind="item.attrs" :input-value="item.selected"
                                    close @click:close="removeChips(index, selectedRoomType)" @click="item.select">
                                    <p class="mb-0 text-truncate" style="max-width: 150px">{{ item.text }}</p>
                                </v-chip>
                                <span v-if="index === 1" class="grey--text caption">(+{{
                                    selectedRoomType.length - 1 }})</span>
                            </template>
                            <template slot="no-data">
                                <div class="no-data">{{ $t("NO_DATA") }}</div>
                            </template>
                        </v-autocomplete>
                    </div>
                    <div class="d-flex ml-3 w-100">
                        <label class="pr-0" style="padding-top: 11px; margin-right: 12px; white-space: nowrap;"> {{
                            $t("SALE_PACKAGE") }} </label>
                        <v-autocomplete item-text="text" item-value="value" :items="listPlans" v-model.lazy="planSelect"
                            outlined chips dense multiple>
                            <template v-slot:prepend-item>
                                <p class="mx-3 mt-1">
                                    <a class="text-primary" @click="planSelect = listPlans.map(e => e.value)">{{
                                        $t('SELECT_ALL') }}</a> | <a class="text-primary" @click="planSelect = []">
                                        {{ $t('UN_SELECT_ALL') }}</a>
                                </p>
                            </template>
                            <template v-slot:selection="{ item, index }">
                                <v-chip color="primary" v-if="index === 0" v-bind="item.attrs" :input-value="item.selected"
                                    close @click:close="removeChips(index, planSelect)" @click="item.select">
                                    <p class="mb-0 text-truncate" style="max-width: 150px">{{ item.text }}</p>
                                </v-chip>
                                <span v-if="index === 1" class="grey--text caption">(+{{ planSelect.length - 1 }})</span>
                            </template>
                            <template slot="no-data">
                                <div class="no-data">{{ $t("NO_DATA") }}</div>
                            </template>
                        </v-autocomplete>
                    </div>
                    <div class="ml-3 d-flex align-items-center">
                        <v-btn color="primary" @click="getPmsRate()">
                            <template>{{ $t("VIEW") }}</template>
                        </v-btn>
                    </div>
                </div>
                <div class="config-price">
                    <div class="w-100" v-if="!isLoadingSearch">
                        <div class="d-sticky h-header-table d-flex px-3">
                            <div class="mr-auto">

                            </div>
                            <div>
                                <div class="small-gutters d-flex">
                                    <div class="text-center font-weight-bold" :style="'width: 94px'" v-for="item in daysOfWeek">
                                        {{ item.value }}</div>
                                </div>
                            </div>
                        </div>
                        <div v-for="(hotel, indexHotel) in dataPmsRate" class="px-3">
                            <label class="label-title py-3">{{ hotel.i18ns.find(item => item.lang === defaultI18n).name
                            }}</label>
                            <div v-for="(room, indexRoom) in hotel.roomTypes">
                                <div v-for="(plan, indexPlan) in room.ratePlans" class="mb-1">
                                    <p class="font-weight-bold mb-1 pl-3">{{ room.i18ns.find(item => item.lang ===
                                        defaultI18n).name
                                    }} -
                                        {{ plan.i18ns.find(item =>
                                            item.lang === defaultI18n).name }}</p>
                                    <template v-for="(date, indDate) in plan.rateRanges">
                                        <div class="d-flex mb-2">
                                            <div class="pb-0 d-date mr-auto pl-3">
                                                <template>
                                                    <div class="d-flex align-items-center">
                                                        <div>
                                                            {{ _moment(date.dateSelect[0]).format("DD/MM/YYYY") }} ~
                                                            {{ _moment(date.dateSelect[1]).format("DD/MM/YYYY") }}
                                                        </div>
                                                        <v-btn color="red" @click="$refs.deleteDialogComponent.open(date)"
                                                            class="ml-1" icon small><i class="icon-delete fs-16"></i></v-btn>
                                                    </div>
                                                </template>
                                            </div>
                                            <div>
                                                <div class="small-gutters">
                                                    <div class="pb-0 pt-0 d-flex align-items-center">
                                                        <currency-ptd
                                                            :classC="'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded text-dark'"
                                                            :options="
                                                                currency == 'VND' ? priceOptionsVi : priceOptionsEn
                                                            " :disabled="true" v-model.lazy="date.paxFriday" />
                                                    </div>
                                                    <div class="pb-0 pt-0 d-flex align-items-center">
                                                        <currency-ptd
                                                            :classC="'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded text-dark'"
                                                            :options="
                                                                currency == 'VND' ? priceOptionsVi : priceOptionsEn
                                                            " :disabled="true" v-model.lazy="date.paxOne" />
                                                    </div>
                                                    <div>
                                                        <currency-ptd
                                                            :classC="'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded text-dark'"
                                                            :options="
                                                                currency == 'VND' ? priceOptionsVi : priceOptionsEn
                                                            " :disabled="true" v-model.lazy="date.paxTwo" />
                                                    </div>
                                                    <div>
                                                        <currency-ptd
                                                            :classC="'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded text-dark'"
                                                            :options="
                                                                currency == 'VND' ? priceOptionsVi : priceOptionsEn
                                                            " :disabled="true" v-model.lazy="date.paxExtra" />
                                                    </div>
                                                    <!-- <div>
                                                        <currency-ptd
                                                            :classC="'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded'"
                                                            :options="
                                                                currency == 'VND' ? priceOptionsVi : priceOptionsEn
                                                            " :disabled="true" v-model.lazy="date.paxFriday" />
                                                    </div>
                                                    <div>
                                                        <currency-ptd
                                                            :classC="'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded'"
                                                            :options="
                                                                currency == 'VND' ? priceOptionsVi : priceOptionsEn
                                                            " :disabled="true" v-model.lazy="date.paxFriday" />
                                                    </div>
                                                    <div>
                                                        <currency-ptd
                                                            :classC="'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded'"
                                                            :options="
                                                                currency == 'VND' ? priceOptionsVi : priceOptionsEn
                                                            " :disabled="true" v-model.lazy="date.paxFriday" />
                                                    </div>
                                                    <div class="mr-0">
                                                        <currency-ptd
                                                            :classC="'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded'"
                                                            :options="
                                                                currency == 'VND' ? priceOptionsVi : priceOptionsEn
                                                            " :disabled="true" v-model.lazy="date.paxFriday" />
                                                    </div> -->
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                            <v-divider class="m-0"></v-divider>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <v-progress-linear color="warning" indeterminate rounded height="3"
            v-if="isLoading || isLoadingSearch"></v-progress-linear>
        <delete-dialog @deleteItem="deleteItem" :maxWidth="325" ref="deleteDialogComponent">
            <span slot="title" v-html="$t('CONFIRM_DELETE_SALE_PACKAGE_DATE_RANGE_PMS')"></span>
        </delete-dialog>
    </div>
</template>
<script>
import moment from "moment";
import { _alert } from "@/_helpers/function.js";
import { PmsRateService } from "@/_services/ChainManage/pmsRate.service.js";
import { chainService } from "@/_services/ChainManage/chain.service.js";
import "vue2-datepicker/index.css";
import DeleteDialog from "@/components/Utils/DeleteDialog.vue";
export default {
    components: {
        "date-picker": () => import('vue2-datepicker'),
        "currency-ptd": () => import('@/components/Utils/Currency-input.vue'),
        "delete-dialog": DeleteDialog,
    },
    data() {
        return {
            panel: [0],
            currency: JSON.parse(localStorage.getItem("currency")),
            multiplierOption: {
                prefix: "",
                locale: "vi",
                length: 3,
                precision: 2
            },
            availOptions: {
                locale: "vi",
                length: 3,
                precision: 0
            },
            listRoom: [],
            listPlans: [],
            planSelect: [],

            isLoading: true,
            isLoadingSearch: false,
            hotels: [],
            langSystem: this.$i18n.locale,
            selecedtHotels: [],
            listRooms: [],
            selectedRoomType: [],
            daysOfWeek: [
                { code: "PRICE", value: this.$t("PRICE") },
                { code: "PAXONE", value: this.$t("PAXONE") },
                { code: "PAXTOW", value: this.$t("PAXTOW") },
                { code: "PAXEXTRA", value: this.$t("PAXEXTRA") },
                // { code: "THU", value: this.$t("THURSDAY") },
                // { code: "FRI", value: this.$t("FRIDAY") },
                // { code: "SAT", value: this.$t("SATURDAY") },
                // { code: "SUN", value: this.$t("SUNDAY") }
            ],
            dataPmsRate: []
        };
    },
    computed: {},
    created() {
        this.currency = this.priceOptionsVi.suffix;
        this.initialize();
    },
    watch: {
    },
    methods: {

        async initialize() {
            this.getHotelByChain();
        },
        async getHotelByChain() {
            this.isLoading = true;
            await chainService.getHotelByChain(this.defaultI18n).then(res => {
                if (res.responseCode == 0) {
                    this.hotels = res.data;
                    this.selecedtHotels = this.hotels.map(e => e.id);
                }
                this.getAllRoom();
            });
        },
        async getAllRoom() {
            let body = {
                keyword: "",
                status: 1,
                limit: 99999,
                offset: 0,
                orderBy: 'active',
                asc: false,
            };

            chainService.getAllRooms(body).then(res => {
                this.listRooms = res.data.map(e => Object.assign({}, {
                    text: e.i18ns.find(item => item.lang === this.defaultI18n).name,
                    value: e.roomCode
                }
                ));
                this.selectedRoomType = this.listRooms.map(e => e.value);
                this.getAllRate()
            });
        },
        async getAllRate() {
            let body = {
                keyword: "",
                status: 1,
                limit: 99999,
                offset: 0,
                orderBy: 'active',
                asc: false,
            };
            chainService
                .getAllRatePlanChain(body)
                .then(res => {
                    this.listPlans = res.data.map(e => Object.assign({}, {
                        text: e.i18ns.find(item => item.lang === this.defaultI18n).name,
                        value: e.ratePlanCode
                    }
                    ));
                    this.planSelect = this.listPlans.map(e => e.value);
                    this.getPmsRate()
                });
        },
        async getPmsRate() {
            this.isLoadingSearch = true;
            const body = {
                hotelIds: [...this.selecedtHotels],
                roomTypeCodes: [...this.selectedRoomType],
                ratePlanCodes: [...this.planSelect]
            };
            await PmsRateService.getPmsRate(body).then((res) => {
                if (res.responseCode === 0) {
                    this.dataPmsRate = res.data;
                    this.dataPmsRate.forEach(element => {
                        element.roomTypes.forEach(room => {
                            room.ratePlans.forEach(plan => {
                                plan.rateRanges.forEach(date => {
                                    date.dateSelect = [
                                        new Date(moment(date.startDate).format("YYYY-MM-DD")),
                                        new Date(
                                            moment(date.endDate)
                                                .format("YYYY-MM-DD")
                                        )
                                    ]
                                })
                            })
                        })
                    });
                } else {
                    _alert(res, this.$t(res.data), false);
                }
                this.isLoadingSearch = false;
                this.isLoading = false
            });
        },
        async deleteItem(date) {
            await PmsRateService.deleteDatePmsRate(date.id).then((res) => {
                if (res.responseCode === 0) {
                    this.getPmsRate();
                    _alert(res, this.$t(res.data), false);
                } else {
                    _alert(res, this.$t(res.data), false);
                }
            })
        },
        _moment: moment
    }
};
</script>
